import React, { useState } from 'react';
import axios from 'axios';
import './SubmissionForm.css';

function SubmissionForm() {
  const [formType, setFormType] = useState('youtube');
  const [formData, setFormData] = useState({
    channel_title: '',
    channel_description: '',
    subscribers: '',
    channel_url: '',
    email: '',
    location: '',
    niche: ''
  });
  const [photos, setPhotos] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    // Check max count
    if (files.length > 3) {
      setError('You can only upload a maximum of 3 photos.');
      setPhotos([]);
      e.target.value = null; // reset
      return;
    }

    // Check sizes
    for (let i = 0; i < files.length; i++) {
      if (files[i].size > 200 * 1024) { // 200 KB
        setError(`File ${files[i].name} exceeds the 200KB limit.`);
        setPhotos([]);
        e.target.value = null; // reset
        return;
      }
    }

    setError('');
    setPhotos(files);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (photos.length === 0) {
      setError('At least one photo is required.');
      return;
    }

    try {
      let endpoint;
      const dataToSend = new FormData();

      // Append files
      photos.forEach(photo => {
        dataToSend.append('photos', photo);
      });

      if (formType === 'youtube') {
        endpoint = '/api/submissions/youtube';
        dataToSend.append('channel_title', formData.channel_title);
        dataToSend.append('channel_description', formData.channel_description);
        dataToSend.append('subscribers', formData.subscribers);
        dataToSend.append('channel_url', formData.channel_url);
        dataToSend.append('email', formData.email);
        dataToSend.append('location', formData.location);
        dataToSend.append('niche', formData.niche);
      } else if (formType === 'instagram') {
        endpoint = '/api/submissions/instagram';
        dataToSend.append('account_name', formData.channel_title);
        dataToSend.append('account_description', formData.channel_description);
        dataToSend.append('followers', formData.subscribers);
        dataToSend.append('instagram_url', formData.channel_url);
        dataToSend.append('email', formData.email);
        dataToSend.append('location', formData.location);
        dataToSend.append('niche', formData.niche);
      } else {
        endpoint = '/api/submissions/blog';
        dataToSend.append('blog_title', formData.channel_title);
        dataToSend.append('blog_description', formData.channel_description);
        dataToSend.append('views_per_month', formData.subscribers);
        dataToSend.append('blog_url', formData.channel_url);
        dataToSend.append('email', formData.email);
        dataToSend.append('location', formData.location);
        dataToSend.append('niche', formData.niche);
      }

      await axios.post(endpoint, dataToSend, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setSubmitted(true);
      setFormData({
        channel_title: '',
        channel_description: '',
        subscribers: '',
        channel_url: '',
        email: '',
        location: '',
        niche: ''
      });
      setPhotos([]);
      document.getElementById('photos').value = null;

      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setError(err.response.data.error);
      } else {
        setError('Error submitting form. Please try again.');
      }
    }
  };

  const getMetricOptions = () => {
    if (formType === 'youtube') {
      return (
        <>
          <option value="BELOW <10K">Below 10K</option>
          <option value="10-50K">10-50K</option>
          <option value="50-100K">50-100K</option>
          <option value="100-500K">100-500K</option>
          <option value="GREATER >500K">Greater 500K</option>
        </>
      );
    } else if (formType === 'instagram') {
      return (
        <>
          <option value="<10K">&lt;10K</option>
          <option value="10-50K">10-50K</option>
          <option value="50-100K">50-100K</option>
          <option value="100-500K">100-500K</option>
          <option value=">500K">&gt;500K</option>
        </>
      );
    } else {
      return (
        <>
          <option value="<10K">&lt;10K</option>
          <option value="10-30K">10-30K</option>
          <option value="30-50K">30-50K</option>
          <option value="50-100K">50-100K</option>
          <option value=">100K">&gt;100K</option>
        </>
      );
    }
  };

  return (
    <div className="form-container">
      <h1>Submit Your Content</h1>

      <div className="form-type-selector">
        <button
          className={`tab-button ${formType === 'youtube' ? 'active' : ''}`}
          onClick={() => {
            setFormType('youtube');
            setFormData({ channel_title: '', channel_description: '', subscribers: '', channel_url: '', email: '', location: '', niche: '' });
          }}
        >
          YouTube Channel
        </button>
        <button
          className={`tab-button ${formType === 'instagram' ? 'active' : ''}`}
          onClick={() => {
            setFormType('instagram');
            setFormData({ channel_title: '', channel_description: '', subscribers: '', channel_url: '', email: '', location: '', niche: '' });
          }}
        >
          Instagram Account
        </button>
        <button
          className={`tab-button ${formType === 'blog' ? 'active' : ''}`}
          onClick={() => {
            setFormType('blog');
            setFormData({ channel_title: '', channel_description: '', subscribers: '', channel_url: '', email: '', location: '', niche: '' });
          }}
        >
          Blog Post
        </button>
      </div>

      {submitted && <div className="success-message">✓ Submission successful! Thank you!</div>}
      {error && <div className="error-message">{error}</div>}

      {formType && (
        <form onSubmit={handleSubmit} className="submission-form dropdown-active">
          <div className="form-group">
            <label htmlFor="title">
              {formType === 'youtube' ? 'Channel Title' : formType === 'instagram' ? 'Account Name' : 'Blog Title'}
            </label>
            <input
              type="text"
              id="title"
              name="channel_title"
              value={formData.channel_title}
              onChange={handleInputChange}
              required
              placeholder={formType === 'youtube' ? 'Enter your channel name' : formType === 'instagram' ? 'Enter your Instagram account name' : 'Enter your blog title'}
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">
              {formType === 'youtube' ? 'Channel Description' : formType === 'instagram' ? 'Account Description' : 'Blog Description'}
            </label>
            <textarea
              id="description"
              name="channel_description"
              value={formData.channel_description}
              onChange={handleInputChange}
              required
              rows="4"
              placeholder={formType === 'youtube' ? 'Describe your channel' : formType === 'instagram' ? 'Describe your Instagram account' : 'Describe your blog'}
            />
          </div>

          <div className="form-group">
            <label htmlFor="metric">
              {formType === 'youtube' ? 'Subscribers' : formType === 'instagram' ? 'Followers' : 'Views per Month'}
            </label>
            <select
              id="metric"
              name="subscribers"
              value={formData.subscribers}
              onChange={handleInputChange}
              required
            >
              <option value="">Select...</option>
              {getMetricOptions()}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="url">
              {formType === 'youtube' ? 'Channel URL' : formType === 'instagram' ? 'Instagram URL' : 'Blog URL'}
            </label>
            <input
              type="url"
              id="url"
              name="channel_url"
              value={formData.channel_url}
              onChange={handleInputChange}
              required
              placeholder="https://..."
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type={formType === 'instagram' ? 'text' : 'email'}
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              placeholder={formType === 'instagram' ? 'your.email@example.com or N/A' : 'your.email@example.com'}
            />
            <p className="form-note">
              <strong>Note:</strong> {formType === 'instagram'
                ? 'Enter N/A if no email is available.'
                : 'For verification, this email must be listed in your account/channel description.'}
            </p>
          </div>

          <div className="form-group">
            <label htmlFor="location">Location</label>
            <select
              id="location"
              name="location"
              value={formData.location}
              onChange={handleInputChange}
              required
            >
              <option value="">Select your location...</option>
              <option value="United States">United States</option>
              <option value="India">India</option>
              <option value="UK">UK</option>
              <option value="Europe">Europe</option>
              <option value="Rest of the World">Rest of the World</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="niche">Niche</label>
            <select
              id="niche"
              name="niche"
              value={formData.niche}
              onChange={handleInputChange}
              required
            >
              <option value="">Select your niche...</option>
              <option value="Lifestyle">Lifestyle</option>
              <option value="Travel">Travel</option>
              <option value="Technology">Technology</option>
              <option value="Fitness">Fitness</option>
              <option value="Finance">Finance</option>
              <option value="Food and Cooking">Food and Cooking</option>
              <option value="Education">Education</option>
              <option value="Gaming">Gaming</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="photos">Photos (Max 3, Max 200KB each)</label>
            <input
              type="file"
              id="photos"
              name="photos"
              accept="image/*"
              multiple
              onChange={handleFileChange}
              required
            />
            {photos.length > 0 && (
              <p className="file-count-text">Selected {photos.length} photo(s)</p>
            )}
          </div>

          <button type="submit" className="submit-button">
            Submit {formType === 'youtube' ? 'Channel' : formType === 'instagram' ? 'Account' : 'Blog'}
          </button>
        </form>
      )}
    </div>
  );
}

export default SubmissionForm;
